import React from 'react';
import { createPortal } from 'react-dom';
import './UpgradeModal.css';

const UpgradeModal = ({ isOpen, onClose, onUpgrade }) => {
  if (!isOpen) return null;

  const handleCustomLink = (scheme) => {
    window.location.href = scheme;
  };

  const handleRestorePurchase = () => {
    handleCustomLink('booksummary://restore');
  };

  const handleUpgradeClick = () => {
    // Check URL for AISparkNotes
    const url = window.location.href.toLowerCase();
    const hasAISparkNotes = url.includes('aisparknotes');
    
    if (hasAISparkNotes) {
      // Redirect to Stripe checkout for AISparkNotes
      window.location.href = 'https://buy.stripe.com/00wfZi5Eo9bF3BfaeC0Ba0d';
    } else if (onUpgrade) {
      // Use the provided onUpgrade handler (for BookSummary)
      onUpgrade();
    } else {
      // Fallback to default behavior
      window.location.href = 'booksummary://upgrade';
    }
  };

  const modalContent = (
    <div className="upgrade-modal-overlay">
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>×</button>
        <div className="upgrade-modal-content">
          <h2>Upgrade to Premium</h2>
          <p className="upgrade-trial">🎁 Start with a 3-day free trial</p>
          <p className="upgrade-price">$5.99/month</p>
          
          <div className="upgrade-benefits">
            <h3>Premium Benefits:</h3>
            <ul>
              <li>✨ Unlimited AI-powered book summaries</li>
              <li>📚 Generate summaries for any book</li>
              <li>💾 Save unlimited books to your collection</li>
              <li>⭐ Rate summaries and ask questions</li>
              <li>🚀 Priority support</li>
              <li>📱 Access from any device</li>
            </ul>
          </div>

          <div className="upgrade-actions">
            <button className="btn btn-primary upgrade-btn" onClick={handleUpgradeClick}>
              Upgrade Now
            </button>
          </div>

          <div className="upgrade-links">
            <a 
              href="booksummary://restore" 
              onClick={(e) => {
                e.preventDefault();
                handleRestorePurchase();
              }}
              className="restore-link"
            >
              Restore Purchase
            </a>
            <span> • </span>
            <a 
              href="booksummary://privacy" 
              onClick={(e) => {
                e.preventDefault();
                handleCustomLink('booksummary://privacy');
              }}
            >
              Privacy Policy
            </a>
            <span> • </span>
            <a 
              href="booksummary://terms" 
              onClick={(e) => {
                e.preventDefault();
                handleCustomLink('booksummary://terms');
              }}
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  // Render modal using portal to ensure it's above everything
  return createPortal(modalContent, document.body);
};

export default UpgradeModal;
